import Snackbar from '@mui/material/Snackbar'
import Alert from '@mui/material/Alert'
import { DirectionContext } from '../../context/DirectionProvider';
import { useContext } from "react";

const CustomizedSnackbars = props => {
  const direction = useContext(DirectionContext);
  const { openSnackBar, handleCloseSnackBar, message, position } = props

  return (
    <div>
      <Snackbar
        dir={direction}
        open={openSnackBar}
        autoHideDuration={6000}
        onClose={handleCloseSnackBar}
        anchorOrigin={position}
      >
        <Alert
         dir={direction}
          onClose={handleCloseSnackBar}
          severity={message.type}
          variant='filled'
          className='_wg-dynamic-text'
          sx={{ width: '100%', color: `${message.type === 'warning' ? '#000': ''}`}}
        >
          {message.message}
        </Alert>
      </Snackbar>
    </div>
  )
}
export default CustomizedSnackbars
